(function () {
  'use strict';

  var SECTION_SELECTOR = '.wb-flow-color';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function openCartDrawer() {
    if (typeof window.openCartDrawer === 'function') {
      window.openCartDrawer();
      return true;
    }

    var trigger = document.getElementById('CustomCartTrigger');

    if (trigger) {
      trigger.click();
      return true;
    }

    return false;
  }

  function dispatchCartEvents() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    document.dispatchEvent(new CustomEvent('wb:cart:updated'));
  }

  function setError(form, message) {
    var error = form ? form.querySelector('[data-flow-error]') : null;

    if (!error) return;

    if (!message) {
      error.hidden = true;
      error.textContent = '';
      return;
    }

    error.hidden = false;
    error.textContent = message;
  }

  function setButtonState(button, state) {
    if (!button) return;

    var label = button.querySelector('[data-flow-label]');
    var defaultLabel = button.getAttribute('data-label-default') || (label ? label.textContent : '');
    var loadingLabel = button.getAttribute('data-label-loading') || 'Ajout…';
    var successLabel = button.getAttribute('data-label-success') || 'Ajouté';
    var errorLabel = button.getAttribute('data-label-error') || 'Erreur';

    button.classList.remove('is-loading', 'is-success', 'is-error');

    if (state === 'loading') {
      button.disabled = true;
      button.classList.add('is-loading');
      if (label) label.textContent = loadingLabel;
      return;
    }

    if (state === 'success') {
      button.disabled = false;
      button.classList.add('is-success');
      if (label) label.textContent = successLabel;

      window.setTimeout(function () {
        button.classList.remove('is-success');
        if (label) label.textContent = defaultLabel;
      }, 1300);

      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.classList.add('is-error');
      if (label) label.textContent = errorLabel;

      window.setTimeout(function () {
        button.classList.remove('is-error');
        if (label) label.textContent = defaultLabel;
      }, 1300);

      return;
    }

    button.disabled = false;
    if (label) label.textContent = defaultLabel;
  }

  async function addToCart(form) {
    var variantInput = form.querySelector('[data-flow-variant-input], [name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');

    if (!variantInput || !variantInput.value) {
      throw new Error('Variante introuvable.');
    }

    var variantId = Number(variantInput.value);
    var quantity = quantityInput && quantityInput.value ? Number(quantityInput.value) : 1;

    if (!variantId) {
      throw new Error('Variante invalide.');
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity || 1
          }
        ]
      })
    });

    var data = null;

    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      var message = data && data.description ? data.description : 'Impossible d’ajouter ce produit au panier.';
      throw new Error(message);
    }

    return data;
  }

  function initVariants(card) {
    var variants = card.querySelector('[data-flow-variants]');
    var input = card.querySelector('[data-flow-variant-input]');
    var button = card.querySelector('[data-flow-button]');
    var label = card.querySelector('[data-flow-label]');
    var form = card.querySelector('[data-flow-form]');

    if (!variants || !input || variants.dataset.flowReady === 'true') return;

    variants.dataset.flowReady = 'true';

    variants.addEventListener('click', function (event) {
      var variantButton = event.target.closest('[data-flow-variant]');

      if (!variantButton || variantButton.disabled || variantButton.classList.contains('is-disabled')) return;

      variants.querySelectorAll('[data-flow-variant]').forEach(function (item) {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });

      variantButton.classList.add('is-selected');
      variantButton.setAttribute('aria-pressed', 'true');

      input.value = variantButton.getAttribute('data-variant-id') || input.value;

      var available = variantButton.getAttribute('data-variant-available') === 'true';

      if (button) {
        button.disabled = !available;
        button.classList.remove('is-loading', 'is-success', 'is-error');

        if (label) {
          label.textContent = available
            ? (button.getAttribute('data-label-default') || label.textContent)
            : (button.getAttribute('data-label-soldout') || 'Épuisé');
        }
      }

      setError(form, '');
    });
  }

  function initForms(card) {
    var forms = card.querySelectorAll('[data-flow-form]');

    forms.forEach(function (form) {
      if (form.dataset.flowReady === 'true') return;

      form.dataset.flowReady = 'true';

      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        var button = form.querySelector('[data-flow-button]');

        if (!button || button.classList.contains('is-loading') || button.disabled) return;

        setError(form, '');
        setButtonState(button, 'loading');

        try {
          await addToCart(form);
          dispatchCartEvents();
          openCartDrawer();
          setButtonState(button, 'success');
        } catch (error) {
          setError(form, error && error.message ? error.message : 'Impossible d’ajouter ce produit au panier.');
          setButtonState(button, 'error');
        }
      });
    });
  }

  function initFlowColor(section) {
    if (!section || section.dataset.flowReady === 'true') return;

    section.dataset.flowReady = 'true';

    var track = section.querySelector('.wb-flow-color__track');
    var prevBtn = section.querySelector('.wb-flow-color__arrow--prev');
    var nextBtn = section.querySelector('.wb-flow-color__arrow--next');
    var dots = Array.from(section.querySelectorAll('.wb-flow-color__dot'));
    var counter = section.querySelector('[data-current]');

    if (!track) return;

    var cards = Array.from(track.querySelectorAll('.wb-flow-color__card'));
    var activeIndex = 0;
    var rafId = null;

    cards.forEach(function (card) {
      initVariants(card);
      initForms(card);
    });

    function applyActiveState(index) {
      if (!cards[index]) return;

      cards.forEach(function (c) {
        c.classList.remove('is-active');
      });

      cards[index].classList.add('is-active');
      activeIndex = index;

      var card = cards[index];
      var newBg = card.dataset.bg;
      var newText = card.dataset.text;

      if (newBg) section.style.setProperty('--wb-fl-bg', newBg);
      if (newText) section.style.setProperty('--wb-fl-text', newText);

      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === cards.length - 1;

      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });

      if (counter) counter.textContent = index + 1;
    }

    function findActiveCard() {
      var trackRect = track.getBoundingClientRect();
      var centerPoint = trackRect.left + trackRect.width / 2;
      var minDist = Infinity;
      var closest = 0;

      for (var i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();

        if (rect.right < 0 || rect.left > window.innerWidth) continue;

        var cardCenter = rect.left + rect.width / 2;
        var dist = Math.abs(centerPoint - cardCenter);

        if (dist < minDist) {
          minDist = dist;
          closest = i;
        }
      }

      applyActiveState(closest);
    }

    function scrollToCard(index) {
      if (index < 0 || index >= cards.length) return;

      var card = cards[index];
      var trackW = track.offsetWidth;
      var cardW = card.offsetWidth;
      var scrollPos = card.offsetLeft - (trackW / 2) + (cardW / 2);

      track.scrollTo({
        left: scrollPos,
        behavior: prefersReduced ? 'auto' : 'smooth'
      });
    }

    track.addEventListener('scroll', function () {
      if (rafId) return;

      rafId = requestAnimationFrame(function () {
        findActiveCard();
        rafId = null;
      });
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToCard(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToCard(activeIndex + 1);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        scrollToCard(i);
      });
    });

    var defaultIndex = window.innerWidth < 768 && cards.length > 1 ? 1 : 0;

    applyActiveState(defaultIndex);

    window.setTimeout(function () {
      scrollToCard(defaultIndex);
    }, 60);
  }

  function init(root) {
    var scope = root || document;

    scope.querySelectorAll(SECTION_SELECTOR).forEach(initFlowColor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

})();